<template>
    <div style="position: relative;">
        <div class="phone-backOuter" :style="{width:width+'px'}">
            <img style="width: 100%" :src="'https://yzg-image.oss-cn-hangzhou.aliyuncs.com/versionManagement/bg.png'" />
        </div>
        <div class="phone-logo">
            <img style="width: 100px;height: 100px"
                :src="'https://yzg-image.oss-cn-hangzhou.aliyuncs.com/versionManagement/teacher.png'" />
        </div>
        <div class="phone-content">
            <div class="phone-content-item">
                <img style="width: 30px;height: 30px;margin-top: 7px;"
                    :src="'https://yzg-image.oss-cn-hangzhou.aliyuncs.com/versionManagement/robot.png'" />
                <div class="phone-title">鹦果老师版</div>
            </div>
            <div style="margin-left: 35%;width: 30%;">
                <a-divider />
            </div>
            <div class="phone-content-item">
                {{constants.versionName}} (Build {{constants.versionCode}}) - {{constants.versionMinCode}} MB
            </div>
            <div class="phone-content-item">
                更新于:{{$dateFormat(constants.updateAt)}}
            </div>
            <div class="phone-content-item" style="margin-top: 30px">
                <a-button type="primary" class="button" @click="gotoDownLoad">下载安装</a-button>
            </div>
            <div style="margin-left: 30%;width: 50%;margin-top: 30px">
                <a-divider />
            </div>
            <div class="phone-content-item">
                <span style="font-weight: 600">更新日志：</span>{{constants.changeLog}}
            </div>
        </div>
    </div>
</template>
<script>
    import { gateway } from '@/api/gateway'
    export default {
        data() {
            return {
                constants: {},
                code: '',
                downLoadUrl: '',
                width: '',
            };
        },
        created() {
            this.width = document.body.clientWidth
            console.log('屏幕宽度', this.width)
            this.init()
        },
        mounted() {
            document.title = '鹦果老师版'
        },
        methods: {
            init() {
                gateway('getAppVersion', { appType: 0, platformType: 0 }).then(res => {
                    console.log(res.data.list[0]);
                    this.constants = res.data.list[0]
                    this.downLoadUrl = res.data.list[0].downloadUrl
                })
            },
            gotoDownLoad() {
                window.location.href = this.downLoadUrl
            },
        }
    };
</script>
<style src="./phone.css" />